/**
 * Get translated resource by text codes
 * Yo can add a token object consisting of key - value pairs to replace tokens in the string
 * E.g. 'Order {orderNumber}' can be rendered as as 'Order 999' if you pass { orderNumber: 999 }
 */
export const translation = (textResourceCode: string, tokens?: { [key: string]: string }) => {
  let translation = window?.translations?.[textResourceCode];
  if (tokens) {
    for (let [token, value] of Object.entries(tokens)) {
      translation = translation?.replace(`{${token}}`, value);
    }
  }
  return translation || textResourceCode;
};

// Shortened name
export const t = translation;
